module.exports = __webpack_public_path__ + "img/arm-header-icons-hover-04.6ba9fdbc.svg";